import { logoStyles } from "@insite/content-library/Widgets/Basic/Logo";
import { addToCartButtonStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsAddToCartButton";
import { quantityOrderedStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsQuantityOrdered";
import { shareLinkStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsShareLink";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

Object.assign(shareLinkStyles, {
    ...shareLinkStyles,
    link: {
        link: {
            typographyProps: {
                transform: "uppercase",
                size: 13,
            },
        },
    },
});
